/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GDPRConsentLevel } from './GDPRConsentLevel';
import {
    GDPRConsentLevelFromJSON,
    GDPRConsentLevelFromJSONTyped,
    GDPRConsentLevelToJSON,
} from './GDPRConsentLevel';

/**
 * 
 * @export
 * @interface GDPRConsentRequest
 */
export interface GDPRConsentRequest {
    /**
     * 
     * @type {Array<GDPRConsentLevel>}
     * @memberof GDPRConsentRequest
     */
    consent_levels: Array<GDPRConsentLevel>;
}

/**
 * Check if a given object implements the GDPRConsentRequest interface.
 */
export function instanceOfGDPRConsentRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "consent_levels" in value;

    return isInstance;
}

export function GDPRConsentRequestFromJSON(json: any): GDPRConsentRequest {
    return GDPRConsentRequestFromJSONTyped(json, false);
}

export function GDPRConsentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GDPRConsentRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'consent_levels': ((json['consent_levels'] as Array<any>).map(GDPRConsentLevelFromJSON)),
    };
}

export function GDPRConsentRequestToJSON(value?: GDPRConsentRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'consent_levels': ((value.consent_levels as Array<any>).map(GDPRConsentLevelToJSON)),
    };
}

